import { render, staticRenderFns } from "./SummaryWrapper.vue?vue&type=template&id=2c9eae34&"
import script from "./SummaryWrapper.vue?vue&type=script&lang=js&"
export * from "./SummaryWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SummaryWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports